<template>
    <Content>
        <div
            class="widget scroll-filter"
            style="max-height: 400px; overflow: hidden"
        >
            <WidgetTitleFilter>
                <a
                    data-toggle="collapse"
                    :href="`#${filterId}`"
                    role="button"
                    class="scroll-filter"
                    aria-expanded="true"
                    :aria-controls="filterId"
                >
                    {{ filterLabel }}
                </a>
            </WidgetTitleFilter>
            <div class="collapse show" :id="filterId">
                <div
                    class="widget-body scroll-filter"
                    style="max-height: 300px; overflow: auto"
                >
                    <slot></slot>
                </div>
            </div>
        </div>
    </Content>
</template>

<script>
import { Content } from "./style";
import WidgetTitleFilter from "../../../components/WidgetTitleFilter.vue";

export default {
    name: "FilterItem",
    props: {
        filterLabel: {
            default: null
        },
        filterId: {
            required: true
        }
    },
    components: {
        Content,
        WidgetTitleFilter
    }
};
</script>
